<template lang="pug">
.tag-filters
	button.tag-filters__heading Location Filters 
	.tag-filters__tags 
		<span class="tag-filters__location-checkbox-filter" v-for="tag in tags">
			<input type="checkbox" :value="tag.name" :id="tag.name" :class="{selected: activeTags.includes(tag.name)}" @click="toggleTag($event, tag)"> 
			<label class="checkbox-label" :for="tag.name"> {{tag.display}} </label>
		</span> 
</template>

<script>
import toggle from "../../../../js/plugins/_toggle";
import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
	name: "TagFilters",
	components: {},
	data() {
		return {
			
		};
	},
	computed: {
		...mapGetters([
			"tags",
			"activeTags"
		]),
	},
	methods: {
		...mapMutations([
			"setStateValue"
		]),
		...mapActions([
			"sendLocationRequest"
		]),
		async toggleTag(e, tagObj) {
			let tagNameArr = this.activeTags.map(t => t);
			if (e.target.matches(".selected")) {
				tagNameArr = tagNameArr.filter(n => n != tagObj.name);
			} else {
				tagNameArr.push(tagObj.name);
			}
			this.setStateValue(['activeTags', tagNameArr]);
			this.setStateValue(['page', null]);
			this.sendLocationRequest([false, true]);
		},
	},
	created() {},
	mounted() {
		// Begin toggle replication from _tagFilters.js file
		const trigger = this.$el.querySelector(".tag-filters__heading");
		const content = this.$el.querySelector(".tag-filters__tags");
		const breakpoint = 768;
		let currentWindowWidth = window.innerWidth;
		const config = {
			container: this.$el,
			trigger,
			content
		}
		let t = new toggle(config); // init accordion via $toggle
		window.addEventListener("resize", () => {
			let newWindowWidth = window.innerWidth;
			if (currentWindowWidth <= breakpoint && newWindowWidth > breakpoint ||
				currentWindowWidth > breakpoint && newWindowWidth <= breakpoint)
				{t.close();}
			currentWindowWidth = newWindowWidth;
		});
		// End toggle replication from _tagFilters.js file
	}
};
</script>


<style scoped lang="scss">
.tag-filters {
	margin-bottom: 66px;
	@include mqdn(sm_dn) {
		margin-bottom: 48px;
	}
}
</style>